import React, { useMemo } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import SelectBox from 'LocalGluons/components/SelectBox';
import defaultStyles from './OptionsSelectBox.jss';

export const OptionsSelectBox = ({ heading, onChange, items, selected, testID }) => {
    const memoItems = useMemo(
        () =>
            items.map((item) => ({
                id: item.id,
                label: item.label,
                isSelected: selected === item.id,
                testID: `${testID}_${item.id}`
            })),
        [items, selected]
    );

    const onSelect = (item) => {
        if (onChange) {
            onChange(item.id);
        }
    };

    return (
        <View testID={testID} style={defaultStyles.container}>
            <SelectBox heading={heading.toUpperCase()} onSelect={onSelect} items={memoItems} />
        </View>
    );
};

OptionsSelectBox.defaultProps = {
    onChange: null,
    selected: '',
    testID: 'optionSelectBox'
};

OptionsSelectBox.propTypes = {
    heading: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired
        })
    ).isRequired,
    selected: PropTypes.string,
    testID: PropTypes.string
};
